<div class="flex h-full">
  <section
    class="bg-[url(https://www.thecable.ng/wp-content/uploads/2020/12/NYSC8-e1647431769962.jpg)] bg-cover bg-center bg-no-repeat basis-2/5 hidden md:block"
  >
    <div
      class="flex flex-col justify-center items-center h-[100dvh] bg-black bg-opacity-70"
    >
      <p class="font-bold tw-font-stretch-expanded text-3xl text-white text-center p-3">
        Buy and sell items for NYSC corp members
      </p>
    </div>
  </section>

  <section second class="flex flex-col justify-between basis-full md:basis-3/5">
    <div class="flex-1 flex flex-col justify-center gap-9">
      <h2 class="text-center font-medium text-xl">Sign up</h2>

      <!--
      @todo: if they enter a valid state code, but the year is older than 2023,
      then show a message that they can only sign up for the current or valid years (not more than 2 years ago).
      -->

      <form class="form gap-2" [formGroup]="signupForm">
        <!-- 
        <mat-form-field class="full-width" appearance="fill">
          <mat-label>Firstname</mat-label>
          <input matInput formControlName="first_name" autocomplete="given-name" placeholder="Emeka">
          <mat-error
            *ngIf="signupForm.controls['first_name'].hasError('minlength') && !signupForm.controls['first_name'].hasError('required')">
            Minimum of {{ signupForm.controls['first_name'].errors?.minlength?.requiredLength }} characters
          </mat-error>
          <mat-error *ngIf="signupForm.controls['first_name'].hasError('required')">
            First name is <strong>required</strong>
          </mat-error>
        </mat-form-field>
  
        <mat-form-field class="full-width" appearance="fill">
          <mat-label>Middlename</mat-label>
          <input matInput formControlName="middle_name" autocomplete="additional-name" placeholder="Mariam">
          <mat-error
            *ngIf="signupForm.controls['middle_name'].hasError('minlength')">
            Minimum of {{ signupForm.controls['middle_name'].errors?.minlength?.requiredLength }} characters
          </mat-error>
        </mat-form-field>
  
        <mat-form-field class="full-width" appearance="fill">
          <mat-label>Lastname</mat-label>
          <input matInput formControlName="last_name" autocomplete="family-name" placeholder="Ola">
          <mat-error
            *ngIf="signupForm.controls['last_name'].hasError('last_name') && !signupForm.controls['last_name'].hasError('required')">
            Please enter a valid Last name
          </mat-error>
          <mat-error *ngIf="signupForm.controls['last_name'].hasError('required')">
            Last name is <strong>required</strong>
          </mat-error>
        </mat-form-field>
        -->

        <mat-form-field class="full-width" appearance="fill">
          <mat-label>Email</mat-label>
          <input
            matInput
            formControlName="email"
            autocomplete="email"
            placeholder="name@site.com"
          />
          <mat-error
            *ngIf="
              signupForm.controls['email'].hasError('pattern') &&
              !signupForm.controls['email'].hasError('required')
            "
          >
            Please enter a valid email address
          </mat-error>
          <mat-error *ngIf="signupForm.controls['email'].hasError('required')">
            Email is <strong>required</strong>
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" appearance="fill">
          <mat-label>Password</mat-label>
          <input
            #passwordInput
            matInput
            type="password"
            formControlName="password"
            autocomplete="new-password"
            placeholder="Minimum of 6 characters"
          />
          <button
            class="umami--click--toggle-signup-password-view"
            matSuffix
            mat-icon-button
            type="button"
            aria-label="Toggle password visibility"
            (click)="togglePasswordInputIcon()"
          >
            <mat-icon>{{ passwordInputIcon }}</mat-icon>
          </button>
          <mat-hint align="start">Minimum of 6 characters</mat-hint>
          <mat-error
            *ngIf="
              signupForm.controls.password.hasError('minlength') &&
              !signupForm.controls.password.hasError('required')
            "
          >
            Please exceed 6 characters
          </mat-error>
          <mat-error
            *ngIf="signupForm.controls['password'].hasError('required')"
          >
            Password is <strong>required</strong>
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" appearance="fill">
          <mat-label>State code</mat-label>
          <input
            formControlName="state_code"
            matInput
            placeholder="e.g. AB/17A/4567"
          />
          <mat-error
            *ngIf="
              signupForm.controls['state_code'].hasError('pattern') &&
              !signupForm.controls['state_code'].hasError('required')
            "
          >
            Please enter a valid state code
          </mat-error>
          <mat-error
            *ngIf="signupForm.controls['state_code'].hasError('required')"
          >
            State code is <strong>required</strong>
          </mat-error>
        </mat-form-field>

        <!-- TODO: disable until state code is valid -->
        <mat-form-field class="">
          <mat-label>LGA</mat-label>

          <mat-select formControlName="lga">
            <mat-option
              *ngFor="let lga_name of selected_state_lgas"
              [value]="lga_name"
            >
              {{ lga_name }}
            </mat-option>
          </mat-select>
          <mat-hint *ngIf="!signupForm?.get(['lga'])?.value"
            >Enter your state code to select LGA</mat-hint
          >
          <mat-error *ngIf="signupForm?.get(['lga'])?.hasError('required')">
            LGA is <strong>required</strong>
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" appearance="fill">
          <mat-label>Invite code</mat-label>
          <input
            formControlName="ref_code"
            matInput
            placeholder="xyz123"
          />
          <mat-hint align="start">
            <b>Optional</b>. If you have a referral code, enter it here.
          </mat-hint>
        </mat-form-field>

        <app-progress-button
          type="submit"
          class="signup-button"
          (click)="signUp()"
          buttonText="Sign up"
          [loading]="isSigningUp"
          [disabled]="signupForm.invalid || isSigningUp"
        ></app-progress-button>
      </form>
    </div>

    <div class="text-center mb-[5%]">
      Have an account?
      <a class="underline text-blue-700" routerLink="/login">Login</a>.
    </div>
  </section>
</div>
